<template>
  <div class="introduction-container">
    <div class="breadcrumbs mb-40">
      <breadcrumb path="/documentation/introduction" name="Homepage" :routeName="route.name" />
    </div>
    <div class="title">
      API Call Flows
    </div>
    <section class="api-flow">
      <div class="submenu-container mb-70">
        <div class="mb-40 font-w-bold">
          Upload Item & Model
        </div>
        <img src="/img/assets/api-call-flow/flow.png" />
      </div>
    </section>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'

const route = useRoute()
</script>

<style lang="scss" scoped>
.submenu-container {
  max-width: 75%;
}
</style>
